/**
 * Standalone, Keycloak-free landing page for a document-signature request's return URLs.
 *
 * Runs in main.tsx BEFORE — and INSTEAD OF — the normal bootstrap for
 * `/document-signature/{requestId}/{done|declined|closed}`. The signer is an external client with no
 * Entite login, so the authenticated SPA (login-required, then the app shell) must never run for
 * them. Same pattern as signing-return-standalone and verify-standalone: no Router, no
 * AuthProvider, no QueryClient, no API call.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import type { DocumentSignatureReturnOutcome } from './document-signature-return-path';
import { DocumentSignatureReturnApp } from './DocumentSignatureReturnApp';

export function runDocumentSignatureReturnApp(outcome: DocumentSignatureReturnOutcome): void {
  const root = document.getElementById('root');
  if (!root) return;
  createRoot(root).render(
    <StrictMode>
      <DocumentSignatureReturnApp outcome={outcome} />
    </StrictMode>,
  );
}
